// @flow

import { Component } from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import {
  receiveAssortment,
  generateFacets,
  updateAssortmentSort,
  getFiltersFromUrl,
  filterAssortment,
} from '../../store/assortment';
import {
  getActiveRoute,
  type RouteItem,
  getActiveRoutePdbIds,
} from '../../store/routes';

type OwnProps = {|
  children: Node,
|};

type StateProps = {|
  pdbIds: ?Array<?string>,
  activeRoute: ?RouteItem,
|};

type DispatchProps = {|
  setAssortment: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

class AssortmentStoreProvider extends Component<Props> {
  constructor(props: Props) {
    super(props);
    this.setAssortment();
  }

  componentDidUpdate(prevProps: Props) {
    const { activeRoute } = this.props;
    if (prevProps.activeRoute !== activeRoute) {
      this.setAssortment();
    }
  }

  setAssortment = () => {
    const { pdbIds, setAssortment } = this.props;

    if (pdbIds) {
      setAssortment(pdbIds);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

const mapStateToProps = (state): StateProps => ({
  pdbIds: getActiveRoutePdbIds(state),
  activeRoute: getActiveRoute(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  setAssortment: pdbIds => {
    dispatch(getFiltersFromUrl());
    dispatch(receiveAssortment(pdbIds));
    dispatch(generateFacets());
    dispatch(filterAssortment());
    dispatch(updateAssortmentSort());
  },
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(AssortmentStoreProvider);
